import { render, staticRenderFns } from "./arkmanxmlexport.vue?vue&type=template&id=1521637e"
import script from "./arkmanxmlexport.vue?vue&type=script&lang=js"
export * from "./arkmanxmlexport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports